export const analyticsTypes = {
  SET_ELIGIBLE_PRODUCTS_LIST: "SET_ELIGIBLE_PRODUCTS_LIST",
  SET_LOADING: "SET_LOADING",
  SET_DASHBOARD_DATA: "SET_DASHBOARD_DATA",
};
